module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAe0lEQVQ4T2NkaDjnx8DwdyYDA6MEA1Hg/wsGBuZ0RoaG08+J1wQ3+QUjQ8OZ/0RZhKZoEGv8X2/MwNh4Fu5gFKeiS8JUYRPH8CO6IlyGYQ0cmGJcmkAuwRmq+DTh1UgobimJR3KTXONpf4b/jDMYGBiITOQMLxgY/2cAAJ1LQJpKNj6hAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/check.png
// module id = RMlS
// module chunks = 1